module.exports = __webpack_public_path__ + "assets/images/project/head/default.png?v=4ca2bb9a";